import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LoginForm from '../forms/login/loginform';
import LogoutForm from './logoutform';
import MQTTLog from '../forms/mqtt_monitor/mqtt_log';
import EventsList from '../forms/race_feed/events_list';
import EventDetails from '../forms/race_feed/event_details';
import HistoryEventDetails from '../forms/race_feed/history_event_details';
import adminList from '../forms/admin/admin_list';
import companiesList from '../forms/companies/companies_list';
import subscribersList from '../forms/subscribers/subscribers_list';
import subscriptionsList from '../forms/subscriptions/subscriptions_list';
import controllerList from '../forms/controller/controller_list';
import moduleList from '../forms/modules/module_list';
import moduleEdit from '../forms/modules/module_edit';
import configForm from '../forms/config/config_list';
import logsList from '../forms/logs/logs_list';
import CalendarList from '../forms/calendar/calendar_list';
import MenuMobile from './menus/menumobile';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import ProtectedForm from "./protected_form";



class RouterForm extends React.Component {
    isAuth() {
        if (!this.props.isAuth) {
            return (
                <Route path="/" component={LogoutForm} />
            )
        }
    }
    main_route() {
        return (
            <Router history={this.props.history}>

                <Switch>
                    <Route path="/login" component={LoginForm} />
                    {this.isAuth()}
                    <ProtectedForm>
                        <Route path="/menumobile" component={MenuMobile} />
                        <Route path="/mqtt_log" component={MQTTLog} />
                        <Route path="/events_list" component={EventsList} />
                        <Route path="/event/details" component={EventDetails} />
                        <Route path="/event/history_details" component={HistoryEventDetails} />
                        <Route path="/subscribers_list" component={subscribersList} />
                        <Route path="/subscriptions_list" component={subscriptionsList} />
                        <Route path="/admin_list" component={adminList} />
                        <Route path="/companies_list" component={companiesList} />
                        <Route path="/controller_list" component={controllerList} />
                        <Route path="/module_list" component={moduleList} />
                        <Route path="/module/:mode" component={moduleEdit} />
                        <Route path="/config" component={configForm} />
                        <Route path="/logs_list" component={logsList} />
                        <Route path="/calendar" component={CalendarList} />
                        <Route path="/logout" component={LogoutForm} />
                    </ProtectedForm>
                </Switch>

            </Router>

        )
    }
    desktop_wrap() {
        return (
            <MediaQuery minWidth={701} className="desktop_wrap">
                <div className="desktop_wrap">
                    {this.main_route()}
                </div>
            </MediaQuery>
        )
    }
    mobile_wrap() {
        return (
            <MediaQuery maxWidth={700} className="mobile_wrap">
                <div className="mobile_wrap">
                    {this.main_route()}
                </div>
            </MediaQuery>
        )
    }
    render() {
        return (
            <div className="page">
                {this.mobile_wrap()}
                {this.desktop_wrap()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        isAuth: state.authR.isAuth
    };
}

export default RouterForm = connect(
    mapStateToProps, null)(
        RouterForm
    );


